module.exports = {
      id: "icon-whatsapp-usage",
      viewBox: "0 0 25.91 25.969",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-whatsapp",
      toString: function () {
        return this.url;
      }
    }